import shortid from "shortid";

export const generateComponentUniqueKey = (): string => shortid.generate();
